import gql from 'graphql-tag';

const query = gql`
  query FavoriteMeals($text: String) {
    diabetes {
      userDiabetes {
        diabeticDietConfig {
          showCarbohydrateUnit
          showProteinFatUnit
          showAssimilableCarbohydrate
        }
      }
    }
    me {
      id
      diet {
        dietId: id
        availableDays {
          date
        }
      }
      favoriteMeals(text: $text) {
        id
        kcal
        preparationTime {
          years
          months
          days
          hours
          minutes
          seconds
        }
        preparationImageUrl
        publicName
        name
        dietId
        mealType
        diabeticDetails {
          carbohydrateUnit
          fatProteinUnit
        }
        mealCustomTag {
          label
          color
        }
      }
    }
  }
`;

export default query;
